import { createFileRoute } from '@tanstack/react-router';
import { CloseHubShell } from '@/components/finance/close';
import {
  parseSortRouteSearch,
  type SortRouteSearch,
} from '@/lib/finance/searchParamNamespace';

/**
 * CPH-001 / CPH-006 / CPH-011: Parent layout for the Close-the-period
 * hub. CPH-011 graduates the file into a real dispatcher shell —
 * {@link CloseHubShell} reads the search-param contract, mounts
 * `RefundDialog` for `?action=refund`, renders the persistent
 * "Back to report" affordance for `?returnTo=report&reportId=…`, and
 * still owns the `<Outlet />` so every sub-route (index spine, Sort,
 * Reconcile) renders below the same affordance row.
 *
 * `validateSearch` is load-bearing for the dispatcher: TanStack Router only
 * surfaces search params that a matched route validates. Without it the
 * parent route stripped `action` / `contributionId` before
 * `CloseHubShell`'s `useSearch({ strict: false })` could read them, so a
 * `?action=refund&contributionId=…` deep-link rendered nothing. The shared
 * `parseSortRouteSearch` validates the whole Close-hub param vocabulary
 * (including `action` + `contributionId`) so the dispatcher path works.
 */
export const Route = createFileRoute('/admin/finance/close')({
  validateSearch: (search: Record<string, unknown>): SortRouteSearch =>
    parseSortRouteSearch(search),
  component: CloseHubShell,
});
